import React from "react";

/**
 * iCaard brand mark — official Ghana-flag SIM-card logo.
 * The image lives in /public/icard-logo.png. We render it at the requested
 * pixel size and (optionally) keep the wordmark "iCaard" beside it.
 */
export default function BrandMark({ size = 48, withText = true, className = "" }) {
  const logoH = Math.min(size + 4, 64);
  // Responsive scaling — on mobile phones the full 96px logo eats the header
  // width and pushes the notification/sign-out icons against it. Use a smaller
  // size on `<sm` screens via CSS clamp so it stays legible without crowding.
  const mobileMax = Math.min(44, size);
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img
        src="/icaard-logo-transparent.png"
        alt="iCaard"
        style={{ height: `clamp(${mobileMax}px, 12vw, ${logoH}px)`, width: "auto", maxHeight: "none" }}
        className="select-none object-contain"
        draggable={false}
      />
    </div>
  );
}
